<template>
  <div class="user-info__content"
    :class="{ 'require-password': isShowPasswordChecker }">
    <password-checker v-if="isShowPasswordChecker"/>
    <router-view v-else/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { parse, isBefore } from 'date-fns'
import { storageManager, STORAGE_KEY } from '@/libs/storage-manager'
import PasswordChecker from '@/components/user-info/PasswordChecker'

export default {
  components: {
    PasswordChecker
  },
  data () {
    return {
      isShowCouponLayer: false,
      isShowPasswordChecker: true
    }
  },
  computed: {
    ...mapState([
      'userData',
      'myInfoTimestamp'
    ]),
    useDimmed () {
      return this.isShowCouponLayer
    },
    getRouteName () {
      return this.$route.name
    }
  },
  watch: {
    myInfoTimestamp (value) {
      this.checkMyInfoAuth()
    }
  },
  created () {
    this.checkMyInfoAuth()
  },
  methods: {
    ...mapMutations([
      'setMyInfoTimestamp'
    ]),
    checkMyInfoAuth (route) {
      const targetRoute = route || this.$route
      this.isShowPasswordChecker = true
      const isTargetPage = targetRoute.meta.requireMyInfoAuth

      if (!isTargetPage) {
        this.isShowPasswordChecker = false
        return
      }

      let expireTimestamp = this.myInfoTimestamp

      if (!expireTimestamp) {
        expireTimestamp = storageManager.getItem(STORAGE_KEY.myInfoTimestamp)
        this.setMyInfoTimestamp(expireTimestamp)
      }

      if (isTargetPage && expireTimestamp) {
        const expireDate = parse(expireTimestamp)
        const now = new Date()

        if (isBefore(now, expireDate)) {
          this.isShowPasswordChecker = false
        } else {
          this.setMyInfoTimestamp(null)
        }
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.checkMyInfoAuth(to)
    next()
  }
}
</script>

<style lang="scss" scoped>
.user-info__content {
  .view-wrap {
    .content-wrap {
      height: calc(100% - 47px);
    }
  }

  &.require-password {
    position: relative;
  }

  /deep/ .btn__back-to-top {
    position: relative;
    float: right;
    padding-bottom: 25px;
    margin-top: 40px;
  }
}
</style>
